import { ref, listAll, deleteObject, type StorageReference } from 'firebase/storage';
import { storage } from '../services/startStorage';
import { userTempInventoryState } from './userTempInventoryState';

async function deleteFolder(folderRef: StorageReference): Promise<void> {
  const listing = await listAll(folderRef);
  await Promise.all([
    ...listing.items.map((item) =>
      deleteObject(item).catch((err) => {
        console.warn(`Failed to delete temp inventory blob ${item.fullPath}:`, err);
      }),
    ),
    ...listing.prefixes.map((sub) => deleteFolder(sub)),
  ]);
}

/**
 * Deletes every blob under `fileFolder` at any nesting depth (original.<ext>,
 * parsed/, process/, partResolutions.json, parsedEmail.json, ...) by recursively
 * listing what actually exists, then removes the entry from the inventory state.
 * Listing before deleting keeps the operation depth-independent and avoids 404s
 * for stage files that were never produced.
 */
export async function removeFromUserTempInventory(fileFolder: string): Promise<void> {
  await deleteFolder(ref(storage, fileFolder));
  userTempInventoryState.files = userTempInventoryState.files.filter(
    (f) => f.fileFolder !== fileFolder,
  );
}
